import React, { useState, useEffect, Fragment } from 'react';
import Map from './components/Map';
import MapLoader from 'features/search-result/components/MapLoader/MapLoader';

const GOOGLE_MAP_API_KEY = process.env.REACT_APP_MAP_TOKEN || '';

export interface MapComponentProps {
  data: any;
  selectedMarker?: any;
  type?:any
}

// load google map script
const loadGoogleMapScript = (cb: any) => {
    if (typeof window.google === 'object' && typeof window.google.maps === 'object') {
      cb();
    } else {
      const googleMapScript = document.createElement("script");
      googleMapScript.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAP_API_KEY}`;
      window.document.body.appendChild(googleMapScript);
      googleMapScript.addEventListener("load", cb);
    }
}

const GMap: React.FC<MapComponentProps> =({data, selectedMarker,type}) => {
    const [loadMap, setLoadMap] = useState(false);
 
    useEffect(() => {
      loadGoogleMapScript(() => {
        setLoadMap(true)
      });
    }, []);

    const markerSelected =(markerData: any) => {
      selectedMarker(markerData);
    }
   
    return (
      <Fragment>
        {!loadMap ? <MapLoader /> : <Map markerData={data} markerSelected={markerSelected} type={type}/>}
      </Fragment>
    );
}

export default GMap;